import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import React from "react";
import { ConfirmationModificationModal } from "./ConfirmationModificationModal";
import { ConfirmationMessage } from "../SaleSupportShops/ConfirmationMessage";
import { ConfirmationModal } from "./ConfirmationModal";
import AdvancedDisplayNameModal from "@pages/SettingGeneral/DisplayName/AdvancedDisplayNameModal";
import { t } from "i18next";

interface Props {
    isModalOpened: boolean;
    setIsModalOpened: (v: boolean) => void;
    isAddSaleSupportClicked: boolean;
    setIsAddSaleSupportClicked: Function;
    setSaleSupportData: Function;
    setFranchiseDataIsUpdated: (v: boolean) => void;
    isSaleSupportAssociatedModified: boolean;
    setIsSaleSupportAssociatedModified: (v: boolean) => void;
    isMessageModalOpened: boolean;
    setIsMessageModalOpened: (v: boolean) => void;
    isArchived: boolean;
    setIsMessageValidateClicked: (v: boolean) => void;
    isArchivedFranchiseModalOpened: boolean;
    setIsArchivedFranchiseModalOpened: (v: boolean) => void;
    isAdvancedDisplayNameModalOpen: boolean;
    setIsAdvancedDisplayNameModalOpen: (v: boolean) => void;
    advancedDisplayName: any;
    setAdvancedDisplayName: (v: any) => void;
    language: any;
    userData: any;
    shopId: string;
    idsAssociated: string[];
    existingSaleSupport: any;
    identifier: string;
    saleSupportLabel: string;
    tagsData: string[];
    i18nextLng: string;
    isConsult: boolean;
    isActionsClicked: boolean;
    setActions: (cb: any) => void;
    setIsActionsClicked: (v: boolean) => void;
    setIsEdited: (v: boolean) => void;
    clearData: () => void;
    clearMultiCustomSelectionData: () => void;
    setTagsData: (v: any) => void;
    saleSupport: any;
}

const SalesSupportModals: React.FC<Props> = ({ ...props }) => (
    <>
        <ConfirmationEditMessage
            isModalOpened={props.isModalOpened}
            setIsModalOpened={props.setIsModalOpened}
            setIsAddClicked={props.setIsAddSaleSupportClicked}
            setEditedData={props.setSaleSupportData}
        />

        {props.isSaleSupportAssociatedModified && (
            <ConfirmationModificationModal
                setSaleSupportData={props.setSaleSupportData}
                data={{
                    [props.identifier]: {
                        id: props.identifier,
                        displayName:
                            props.advancedDisplayName.languages[
                                props.i18nextLng
                            ],
                        shopId: props.shopId,
                        support_de_vente: props.saleSupportLabel,
                        tag: props.tagsData.join(","),
                        isActive: props.existingSaleSupport.isActive,
                        isArchived: false,
                        isFavorite: props.existingSaleSupport.isFavorite,
                        advancedDisplayName: props.advancedDisplayName,
                        isFavoriteFranchise: props.saleSupport.isFavorite,
                    },
                }}
                resetData={() => {
                    props.clearData();
                    props.clearMultiCustomSelectionData();
                    props.setTagsData([]);
                }}
                setIsAddSaleSupportClicked={props.setIsAddSaleSupportClicked}
                setIsEdited={props.setIsEdited}
                isModalOpened={props.isSaleSupportAssociatedModified}
                setIsModalOpened={props.setIsSaleSupportAssociatedModified}
                saleSupport={props.saleSupport}
            />
        )}

        {props.isMessageModalOpened && (
            <ConfirmationMessage
                msg={
                    !props.isArchived
                        ? t(
                              "The sale support already exists in the franchise. Do you want to associate it with this shop"
                          )
                        : t(
                              "Attention! the sales support is already archived at the franchise level"
                          )
                }
                setIsModalOpened={props.setIsMessageModalOpened}
                isModalOpened={props.isMessageModalOpened}
                setIsValidateClicked={props.setIsMessageValidateClicked}
                isArchived={props.isArchived}
            />
        )}

        {props.isArchivedFranchiseModalOpened && (
            <ConfirmationModal
                isConfirmationModal={props.isArchivedFranchiseModalOpened}
                setIsConfirmationModal={props.setIsArchivedFranchiseModalOpened}
            />
        )}

        {props.isAdvancedDisplayNameModalOpen && (
            <AdvancedDisplayNameModal
                isConsult={props.isConsult}
                isAdvancedDisplayNameModalOpen={
                    props.isAdvancedDisplayNameModalOpen
                }
                setIsAdvancedDisplayNameModalOpen={
                    props.setIsAdvancedDisplayNameModalOpen
                }
                setAdvancedDisplayName={props.setAdvancedDisplayName}
                displayName={props.advancedDisplayName}
                language={props.language}
                isActionsClicked={props.isActionsClicked}
                setActions={props.setActions}
                setIsActionsClicked={props.setIsActionsClicked}
                setIsEdited={props.setIsEdited}
            />
        )}
    </>
);

export default SalesSupportModals;
